<div class="dashboard_grid">
  <div class="side_nav_container">
    <sxw-side-nav></sxw-side-nav>
  </div>
  <div class="page_body">
    <div class="top_nav_container">
      <app-top-nav></app-top-nav>
    </div>
    <div class="page_container">
      <div class="page_content">
        <router-outlet></router-outlet>
        <sxw-popup-wrapper />
      </div>
      <div class="actions_nav_container">
        <app-actions-nav name="main" defaultExpandedBy="default"></app-actions-nav>
      </div>
    </div>
  </div>
</div>
